import React from "react";
import OfferPriceDescription from "./OfferPriceDescxription";
import { formatNumber } from "../../../utils";
var OfferItemPrices = function (_a) {
    var title = _a.title, prices = _a.prices, showDescriptions = _a.showDescriptions, addedPrice = _a.addedPrice;
    if (!prices.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        title ? React.createElement("h4", null, title) : null,
        React.createElement("ul", null, prices.map(function (price, index) { return (React.createElement("li", { key: index },
            React.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                } },
                React.createElement("div", null, price.title),
                price.price ? (React.createElement("span", { style: { minWidth: 60, textAlign: "right" } },
                    addedPrice ? "+" : "",
                    formatNumber(price.price, 2, ",", "."),
                    " \u20AC")) : null),
            price.description ? (React.createElement(OfferPriceDescription, { description: price.description, showDescriptions: showDescriptions })) : null)); }))));
};
export default OfferItemPrices;
//# sourceMappingURL=OfferItemPrices.js.map